export default function PHP_realpath() {
  return (
    <div>
      <h1>PHP_realpath</h1>
    </div>
  );
}
